import React from 'react';

export type OrganizationAvatarProps = {
  name: string;
  logoUrl?: string | null;
  brandColor?: string | null;
  size?: 'sm' | 'md';
};

const SIZE_CLASS = {
  sm: 'w-5 h-5 rounded text-[8px]',
  md: 'w-8 h-8 rounded-lg text-xs'
};

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const OrganizationAvatar: React.FC<OrganizationAvatarProps> = ({
  name,
  logoUrl,
  brandColor,
  size = 'md'
}) => {
  const cls = `${SIZE_CLASS[size]} flex items-center justify-center shrink-0 font-bold select-none overflow-hidden`;

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={name}
        className={`${SIZE_CLASS[size]} object-cover shrink-0`}
      />
    );
  }

  const bg = brandColor ?? '#3a4548';
  const border = `1px solid ${hexToRgba(bg, 0.2)}`;

  return (
    <div
      className={cls}
      style={{ background: bg, border, color: '#fff' }}
      aria-label={name}
    >
      {initials(name)}
    </div>
  );
};
